/* eslint-disable no-console */
import CancelablePromise from 'cancelable-promise';
import { ApiResult } from '../types/ApiResult';
import { AppointmentParams } from '../types/AppontmentParams';
import { PostAppointmentResponse } from '../types/PostAppointmentResponse';
import apiClient from './appApi';

export default function postAppointment(
  params: AppointmentParams,
): CancelablePromise<ApiResult<PostAppointmentResponse>> {
  return apiClient.post<ApiResult<PostAppointmentResponse>, {}>(
    '/CMSPages/SonovaBookAppointment/PostAppointment.ashx',
    params,
  );
}
